// Small page widgets: today's letter in the weekly schedule, "your first
// letter" on the confirmed page, and the copy-address button.

export function initWidgets() {
  const dow = new Date().getDay(); // 0 Sun … 6 Sat
  const weekday = dow >= 1 && dow <= 5;

  // Highlight today's letter (or Monday's, on a weekend).
  document.querySelectorAll("[data-week]").forEach((list) => {
    const target = weekday ? dow : 1;
    const item = list.querySelector(`[data-dow="${target}"]`);
    if (!item) return;

    item.classList.add("is-today");
    const badge = document.createElement("span");
    badge.className = "badge";
    badge.textContent = weekday ? "Today" : "Next";
    const day = item.querySelector(".day");
    if (day) day.appendChild(badge);
  });

  // After signing up, the first letter is the next weekday.
  document.querySelectorAll("[data-next-letter]").forEach((list) => {
    const next = dow >= 1 && dow <= 4 ? dow + 1 : 1;
    const item = list.querySelector(`[data-dow="${next}"]`);
    if (!item) return;

    item.classList.add("is-next");
    const note = item.querySelector(".m");
    if (note) note.textContent = "· your first letter";
  });

  // Copy address.
  document.querySelectorAll("[data-copy]").forEach((button) => {
    const label = button.textContent;
    button.addEventListener("click", () => {
      const done = () => {
        button.textContent = "Copied";
        button.classList.add("is-done");
        window.setTimeout(() => {
          button.textContent = label;
          button.classList.remove("is-done");
        }, 2000);
      };

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(button.dataset.copy).then(done, done);
      } else {
        done();
      }
    });
  });

  // "Send the email again" (check-email page): asks the site to resend the
  // confirmation to the address remembered from the form, then cools down.
  document.querySelectorAll("[data-resend]").forEach((button) => {
    const message = document.querySelector("[data-resent]");
    const secs = message ? message.querySelector("[data-secs]") : null;
    let timer;

    button.addEventListener("click", () => {
      let email = "";
      try {
        email = sessionStorage.getItem("wps_email") || "";
      } catch (error) {
        /* storage blocked */
      }

      if (email && button.dataset.ajaxUrl) {
        const body = new URLSearchParams({ action: "wps_resend", email });
        fetch(button.dataset.ajaxUrl, { method: "POST", body }).catch(() => {});
      }

      let left = 60;
      button.hidden = true;
      if (message) message.hidden = false;
      if (secs) secs.textContent = left;

      window.clearInterval(timer);
      timer = window.setInterval(() => {
        left -= 1;
        if (secs) secs.textContent = left;
        if (left <= 0) {
          window.clearInterval(timer);
          button.hidden = false;
          if (message) message.hidden = true;
        }
      }, 1000);
    });
  });
}
